import React from "react";
import WarningIcon from '@material-ui/icons/Warning';
import CircularProgress from '@material-ui/core/CircularProgress'
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { } from "pages/redux/actions";
import axios from 'axios';
import logo from 'assets/img/defu.png';
import Avatar from '@material-ui/core/Avatar';
import logo2 from 'assets/img/noimage2.jpg';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";
// import { useHistory, useLocation } from "react-router-dom";
import { Button, Card, CardHeader, CardFooter,Modal, Tooltip, CardBody, FormGroup, Form, Container, Row,Input, Col,} from "reactstrap";
// core componentsimport React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import UserHeader from "components/Headers/UserHeader.js";
// import { Modal } from "bootstrap";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        large: {
            width: theme.spacing(40),
            height: theme.spacing(40),
        },
    }),
);
const Profile = (props) => {
    // const history = useHistory();
    const classes = useStyles();
    // const location = useLocation();
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // console.log(props)
    var con;
    if (props) {
        // console.log('yes location')
        // console.log(props);
        // console.log(props.match.params);
        if (props.match.params != null) {
            if (props.match.params.id) {
                // console.log('c')
                con = props.match.params.id
                console.log(con)
            }
            else {
                // history.push({
                //     pathname: 'home',
                //     state: {
                //         "token": 1,
                //         "type": "error",
                //         "message": 'Something went wrong'
                //     }
                // })

            }
        }
        else {
            // history.push({
            //     pathname: 'home',
            //     state: {
            //         "token": 1,
            //         "type": "error",
            //         "message": 'Something went wrong'
            //     }
            // })
        }

    }
    else {
        console.log('nope')
    }
    console.log(con)

    const [bgImage, setbgImage] = React.useState(logo);
    const [emailtool, setemailtool] = React.useState(false);
    const [emailsel, setemailsel] = React.useState('Click to Copy Email');
    const [userd, setuserd] = React.useState({});
    const [media, setmedia] = React.useState(false);
    const [reporting, setreporting] = React.useState(false);
    const [repdetails, setrepdetails] = React.useState({});
    const [noposter, setnoposter] = React.useState(false);
    const [disabling, setdisabling] = React.useState(false);
    const [editcontent, seteditcontent] = React.useState('Report');
    const fetchData = React.useCallback(() => {
        // console.log('fetching')
        if(con !== undefined){
            axios.get(process.env.REACT_APP_DOMAIN+"/profile/user2=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    // console.log(response.data)
                    setrepdetails({ 'name': 'Spam', 'reason': '', 'user': response.data.id })
                    // console.log('entered')
                    document.title = response.data.first_name + ' '+response.data.last_name
                    setuserd(response.data)
                    if (response.data.photo != null) {
                        var phurl = process.env.REACT_APP_DOMAIN+'' + response.data.photo;
                        // console.log(phurl)
                        setbgImage(phurl);
                    }
                    else {
                        setbgImage(logo2);
                        setnoposter(true)
                    }
                })
                .catch((error) => {
                    setSendingdata('Something went wrong, Please Try Again')
                    settt('error')
                    setOpen(true);
                })    
        }
        
    }, [con,props.token])
    React.useEffect(() => {
        fetchData()
    }, [fetchData])

    const handleClose = (event, reason) => {
        setOpen(false);
    };
    // console.log(bgImage)


    const toggle = () => {
        setemailtool(!emailtool)
    };


    const handleMedia = (event, img) => {
        // console.log(event)
        // console.log(img)
        // console.log('clicked')
        setmedia(true)
    };

    const CloseMedia = () => {
        setmedia(false)
    };


    const ReportOn = () => {
        setreporting(true)
    };

    const ReportOff = () => {
        setreporting(false)
    };

    const handleChangeEdit = () => {
        seteditcontent(<CircularProgress size="20px" style={{ color: '#172b4d' }} />)
        setdisabling(true)
        // console.log(repdetails)
        axios.post(process.env.REACT_APP_DOMAIN + "/reportaccount",repdetails, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setSendingdata(response.data.message)
                settt('success')
                setOpen(true);
                setrepdetails({ 'name': 'Spam', 'reason': '','user':userd.id })
                setreporting(false)
                setdisabling(false)
                seteditcontent('Report')
                props.fetch()
            })
            .catch((error) => {
                setSendingdata('Something went wrong, Please Try Again')
                settt('error')
                setOpen(true);
                setdisabling(false)
                seteditcontent('Report')
            })
    };

    return (
        <>
            <UserHeader id={props.username} />
            {/* Page content */}
            <Container className="mt--4" fluid>
                <Row>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <meta name="theme-color" content="#ffffff" />
                        <meta name="description" content={userd.username +' • '+userd.email+'  • '+(userd.is_superuser===true ? 'Super Admin': userd.is_staff===true? 'Faculty': 'Student')} />
                        <meta property="og:description" content={userd.username + ' • ' + userd.email + '  • ' + (userd.is_superuser === true ? 'Super Admin' : userd.is_staff === true ? 'Faculty' : 'Student')} />
                        <meta property="og:title" content='DepAct' />
                        <meta property="og:type" content="Profile" />
                        <meta property="og:url" content={"https://depact-kjsieit.vercel.app/main/profile/" + userd.username} />
                    </Helmet>
                    <Col className="order-xl-1" xl="12">
                        <Card className={"shadow cardbg-"+props.theme}>
                            <Row className="justify-content-center">
                                <Col className="order-lg-2 mt--3" lg="3">
                                    <div className="card-profile-image bg-pinkc" style={{ borderRadius: '500px',zIndex: 9 }} onClick={(event) => (noposter ? console.log('') : handleMedia(event, bgImage))}>
                                        <Avatar src={bgImage} onError={(e) => { e.target.src = 'https://i.ibb.co/drffP5L/place.png' }} style={{ zIndex: 12, backgroundColor: '#f8f9fe',maxWidth: '200px',maxHeight: '200px',paddingTop: '100px' }} className={classes.large+' rounded-circlec'} ></Avatar>
                                    </div>
                                </Col>
                            </Row>
                            <CardHeader className={"border-0 cardbg-" + props.theme}>
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className="mb-0">User Profile</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className={"cardbg-" + props.theme}>
                                <Form>
                                    <h6 className="heading-small text-muted mb-4">
                                        Main info
                                    </h6>
                                    <div className="">
                                        <Row>
                                            <Col xl="3" md="6" lg="3" sm="6" >
                                                <FormGroup>
                                                    <label className="form-control-label"htmlFor="input-username">Username</label>
                                                    <p>{userd.username}</p>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="3" md="6" lg="3" sm="6" >
                                                <FormGroup>
                                                    <label className="form-control-label"htmlFor="input-fname">First Name</label>
                                                    <p>{userd.first_name}</p>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="3" md="6" lg="3" sm="6" >
                                                <FormGroup>
                                                    <label className="form-control-label"htmlFor="input-lname">Last Name</label>
                                                    <p>{userd.last_name}</p>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="3" md="6" lg="3" sm="6" >
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-contact">Contact Info</label>
                                                    <p>{userd.contactinfo1}</p>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="3" md="6" lg="3" sm="6" >
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-email">Email</label>
                                                    <div><p id="EmalCopy" onClick={(e) => { navigator.clipboard.writeText(userd.email); setemailsel('Copied the Email') }} style={{ display: 'inline-block' }} className="point">{userd.email}</p></div>
                                                    <Tooltip target="EmalCopy" isOpen={emailtool} toggle={toggle} >
                                                        {emailsel}
                                                    </Tooltip>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <hr className="my-4" />
                                    <h6 className="heading-small text-muted mb-4">
                                        Main info
                                    </h6>
                                    <div className="">
                                        <Row>
                                            <Col xl="3" md="6" lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-type">Account Type</label>
                                                    <p>{userd.type}</p>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="3" md="6" lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-idno">ID No</label>
                                                    <p>{userd.idno}</p>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="3" md="6" lg="6">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-department">Department</label>
                                                    <p>{userd.department}</p>
                                                </FormGroup>
                                            </Col>
                                            {(userd.is_staff ?
                                                <Col xl="3" md="6" lg="6">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-department">Designation</label>
                                                        <p>{userd.designation}</p>
                                                    </FormGroup>
                                                </Col>
                                                :
                                                <div>
                                                    <Col xl="3" md="3" lg="3">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-year">Year</label>
                                                            <p>{userd.year}</p>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xl="3" md="3" lg="3">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-division">Division</label>
                                                            <p>{userd.division}</p>
                                                        </FormGroup>
                                                    </Col>
                                                </div>
                                            )}
                                        </Row>
                                    </div>
                                </Form>
                            </CardBody>
                            {(userd.id === props.username ?
                            <div></div>
                            :
                            <CardFooter className={"cardbg-" + props.theme}>
                                <div className="text-center">
                                    <Button color="danger" outline onClick={ReportOn}>
                                        <WarningIcon className="mr-1 " style={{ width: 18 }}/>
                                        Report
                                    </Button>
                                </div>
                            </CardFooter>
                            )}
                            <Modal
                                className="modal-dialog-centered"
                                isOpen={reporting}
                                toggle={ReportOff}>
                                <div className="modal-header">
                                    <h2 className="modal-title mt-2 mb-0" id="modal-title-default">  Report Account </h2>
                                    <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={ReportOff}> <span aria-hidden={true}>×</span> </button>

                                </div>
                                <div className="pl-2 pr-2">
                                    <Col lg="12">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-year-name">Report As</label>
                                            <Input className="form-control-alternative" onChange={(e)=>setrepdetails({...repdetails,[e.target.name]: e.target.value})} name="name" value={repdetails.name} id="input-year-name" placeholder="Report As" type="select" >
                                                <option value="Spam">Spam</option>
                                                <option value="Inappropriate">Inappropriate</option>
                                                <option value="He Should'nt be here">He Should'nt be here</option>
                                                <option value="Thats me">Thats me</option>
                                                <option value="Phishing">Phishing</option>
                                            </Input>
                                        </FormGroup>
                                    </Col><Col lg="12">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-division-name">Reason</label>
                                            <Input className="form-control-alternative" onChange={(e)=>setrepdetails({...repdetails,[e.target.name]: e.target.value})} name="reason" value={repdetails.reason} id="input-division-name" placeholder="Reason" type="text" />
                                        </FormGroup>
                                    </Col>
                                </div>
                                <div className="modal-footer bg-tealx pt-0">
                                    <Button color="inf" data-dismiss="modal" type="button" onClick={ReportOff}> Close </Button>
                                    <Button className="ml-auto" color="danger" onClick={handleChangeEdit} disabled={disabling} outline> {editcontent === 'Report' ?
                                        <WarningIcon className="mr-1 " style={{ width: 18 }} />
                                        :
                                        <div></div>
                                    }{editcontent} </Button>
                                </div>
                            </Modal>
                        </Card>
                    </Col>
                </Row>
                {media &&
                    <div className="text-center" onClick={CloseMedia} style={{ height: '100vh', width: '100vw', backgroundColor: 'black', position: 'fixed', top: 0, left: 0, zIndex: 10, opacity: '100%' }}>
                        <img alt="Event Poster" style={{ height: '100%', width: 'auto', opacity: '100%', zIndex: 11 }} src={bgImage} onError={(e)=>{e.target.src='https://i.ibb.co/drffP5L/place.png'}} />
                    </div>}
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Profile);
